/**
 *
 * MeetingStatus
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import Icon from 'components/media/Icon/index.js';
import useVideoEnabled from 'components/VideoConf/useVideoEnabled.js';
import { makeDateTimeString } from 'utils/eventTimes.js';
import { isPast, isFuture, format } from 'utils/date-fns/index.js';
import messages from './messages.js';
import { LOCATION_TYPE_PREMISES, LOCATION_TYPE_VIDEO } from '../Planner/SelectLocationType/constants.js';
import MeetingAssigned from './MeetingAssigned.jsx';
import MeetingButton from './MeetingButton.jsx';
import MeetingVideo from './MeetingVideo.jsx';

function MeetingStatus(props) {
  const { meeting } = props; // Can be used without studentId to show all all children
  const { assigned, slots, set } = meeting.details;
  const [videoEnabled] = useVideoEnabled();
  const intl = useIntl();
  const meetingLocationType = meeting.meetingLocationType || set.meetingLocationType;

  function dateObject(date) {
    return { date: format(date, 'PPPP p') };
  }

  function getLocationMessage() {
    switch (meetingLocationType) {
      case LOCATION_TYPE_PREMISES:
        return messages.onPremises;
      case LOCATION_TYPE_VIDEO:
        return messages.videoMeeting;
      default:
        return null;
    }
  }

  const locationMessage = getLocationMessage();
  const location = locationMessage && (
    <div>{`${intl.formatMessage(messages.location)}: ${intl.formatMessage(locationMessage)}`}</div>
  );
  if (assigned) {
    return (
      <div>
        <div className="text-success d-flex mb-3">
          <Icon inline className="ss-checkmark me-3" />
          <div>
            {slots.map((slot) => (
              <div key={slot.id}>{makeDateTimeString(slot)}</div>
            ))}
            {videoEnabled && location}
          </div>
        </div>
        { videoEnabled && <MeetingVideo meeting={meeting} />}
        <MeetingAssigned meeting={meeting} />
      </div>
    );
  }

  const { registerStart, registerClose } = set;
  if (isPast(registerClose)) {
    return (
      <div className="text-danger">
        <FormattedMessage {...messages.registrationClosed} />
      </div>
    );
  }
  return isFuture(registerStart) ? (
    <div className="text-info">
      <div><FormattedMessage {...messages.registerFrom} values={dateObject(registerStart)} /></div>
      {videoEnabled && location}
      <div className="mt-3"><MeetingButton meeting={meeting} message={messages.preview} /></div>
    </div>
  ) : (
    <div className="text-warning">
      <div><FormattedMessage {...messages.registerBefore} values={dateObject(registerClose)} /></div>
      {videoEnabled && location}
      <div className="mt-3"><MeetingButton meeting={meeting} message={messages.register} /></div>
    </div>
  );
}

MeetingStatus.propTypes = {
  meeting: PropTypes.object,
};

export default MeetingStatus;
